import React, { useContext } from "react";
import LoginTop from "../../../assets/images/LoginPicture/LoginTop.png";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import OutLook from "../../../assets/images/LoginPicture/OutLook.png";
import Mask from "../../../assets/images/LoginPicture/Mask.png";
import { getLogin } from "./redux/actionCreator";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../axios";
import { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import RouteContext from "../../../utils/context/RouteContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const Login = () => {
  const matches=useMediaQuery("(max-width:1280px)");
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allowedRoutes } = useContext(RouteContext);
  const token = localStorage.getItem("token");
  const [outlookError, setOutlookError] = useState("");
  const loginerror = useSelector((state) => state.isLoggedIn);
  const forgotPassword = () => {
    navigate("/forgotpassword");
  };
  const [toastToken, setToastToken] = useState(0);
  const [passwordType, setPasswordType] = useState("password");
  // Logic for login
  const onSubmit = (data) => {
    console.log("Login Info", data);

    const response = dispatch(getLogin(data));
    console.log("response inside login jsx data", response);
    const pollToken = setInterval(() => {
      const token = localStorage.getItem("token");
      if (token) {
        clearInterval(pollToken);
        navigate("/dashboard");
      } else {
        setToastToken(1);
      }
    }, 1000);
  };
  // const IsloggedIn = useSelector((state)=>state?.login?.isLoggedIn)
  // console.log("islogged in ",IsloggedIn);
  // if(IsloggedIn)
  // {

  // }else{

  // }
  // Logic for outlook login
  const handleOutlookLogin = async () => {
    try {
      const response = await axiosInstance.get("team/auth-url");
      // console.log("Outlook Login Response", response);
      const url = response?.data?.payload?.url;
      window.location.href = url;
    } catch (error) {
      // console.error("Outlook Login Error", error);
      setOutlookError("Failed to log in with Outlook. Please try again.");
    }
  };
  // console.log("Token from local storage inside Login:", token);

  // show password
  const handleShowPassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          paddingBottom: "3%",
          paddingTop: "3%",
          background:
            "linear-gradient(180deg, #000000 12.64%, rgba(255, 255, 255, 0) 200.18%)",
        }}
      >
        <div
          style={{
            zIndex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: matches?"25rem":"26rem",
            height: "auto",
            padding: matches?"1rem 1.4rem":"2rem 2.4rem",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
          }}
        >
          <div style={{ marginTop: ".6rem" }}>
            <img src={LoginTop} alt="Login Top" style={{ height: "4rem" }} />
          </div>
          <div style={{ marginTop: "0rem" }}>
            <span
              style={{
                fontweight: "600",
                fontSize: "1.5rem",
                color: "#000000",
              }}
            ></span>
            <Typography component="div">
              <Box
                sx={{
                  fontWeight: "bold",
                  m: 1,
                  fontSize: "17px",
                  lineHeight: "27px",
                }}
              >
                Dev Labs Alliance
              </Box>
            </Typography>
          </div>
          <div style={{ marginTop: "0rem", marginBottom: ".4rem" }}>
            <Typography component="div">
              <Box
                sx={{
                  fontWeight: "700",
                  m: 1,
                  fontSize: "17px",
                  lineHeight: "27px",
                  color: "#333333",
                }}
              >
                Admin Sign-In
              </Box>
            </Typography>
          </div>
          {/* Form component here */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: ".6rem",
              }}
            >
              <label htmlFor="email" style={{ marginBottom: ".6rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                    color: "#000000",
                    fontSize: "14px",
                  }}
                >
                  Email
                </span>
              </label>
              <input
                id="email"
                type="email"
                {...register("email")}
                style={{
                  width: "20rem",
                  padding: ".6rem",
                  // height: "2.8rem",
                  border: "1px solid #D9D9D9",
                  outline: "none",
                  borderRadius: "6px",
                }}
                placeholder="Enter Email Id"
              ></input>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: ".6rem",
                marginBottom: ".6rem",
                position: "relative",
              }}
            >
              <label htmlFor="password" style={{ marginBottom: ".6rem" }}>
                <span
                  style={{
                    fontWeight: "600",
                    color: "#000000",
                    fontSize: "14px",
                  }}
                >
                  Password
                </span>
              </label>
              <input
                id="password"
                type={passwordType}
                {...register("password")}
                style={{
                  width: "20rem",
                  padding: ".6rem",
                  // height: "2.8rem",
                  border: "1px solid #D9D9D9",
                  outline: "none",
                  marginBottom: ".5rem",
                  borderRadius: "6px",
                }}
                placeholder="Enter Password"
              ></input>
              {passwordType === "text" ? (
                <VisibilityIcon
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    right: "10px",
                    cursor: "pointer",
                    color: "#A6A6A6",
                  }}
                  onClick={handleShowPassword}
                />
              ) : (
                <VisibilityOffIcon
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    right: "10px",
                    cursor: "pointer",
                    color: "#A6A6A6",
                  }}
                  onClick={handleShowPassword}
                />
              )}
            </div>
            <div style={{ marginBottom: ".4rem", marginTop: ".5rem" }}>
              <Button
                type="submit"
                sx={{
                  width: "20rem",
                  // height: "3rem",
                  backgroundColor: "#1A5AFA",
                  marginTop: ".5rem",
                  textTransform: "none",
                }}
                variant="contained"
              >
                Sign In
              </Button>
            </div>
            {/* divider  */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  flexGrow: 1,
                  height: "1px",
                  backgroundColor: "#BFBFBF",
                  marginRight: "10px",
                  marginLeft: "10px",
                }}
              ></span>
              <span
                style={{
                  color: "#BFBFBF",
                }}
              >
                or
              </span>
              <span
                style={{
                  flexGrow: 1,
                  height: "1px",
                  backgroundColor: "#BFBFBF",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              ></span>
            </div>
            <div style={{ marginBottom: ".4rem", marginTop: ".5rem" }}>
              <Button
                onClick={handleOutlookLogin}
                // type="submit"
                sx={{
                  width: "20rem",
                  // height: "3rem",
                  backgroundColor: "#1D70B6",
                  textTransform: "none",
                }}
                variant="contained"
              >
                <img
                  style={{ width: "2rem", height: "2rem" }}
                  src={OutLook}
                  alt="OutLook here"
                />
                Sign in with Outlook
              </Button>
            </div>

            <div style={{ display: "flex", marginTop: "1.4rem" }}>
              <div style={{ color: "#8C8C8C", marginLeft: "1rem" }}>
                Forgot your password?
              </div>
              <div>
                <span
                  onClick={forgotPassword}
                  style={{
                    color: "#1A5AFA",
                    margin: "1rem",
                    cursor: "pointer",
                    marginRight: "1rem",
                    fontWeight: "600",
                  }}
                >
                  Reset Password
                </span>
              </div>
            </div>
          </form>
        </div>
        <div>
          <img
            src={Mask}
            style={{
              width: "100%",
              position: "absolute",
              bottom: "0",
              left: "0",
              zIndex: "0",
            }}
            alt="hi"
          />
        </div>
      </div>
    </>
  );
};

export default Login;
